import React from 'react';
import { Button } from 'react-bootstrap';

const timeOf = (date) =>
    date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

/**
 * One line saying whether the form's progress is saved, from
 * useSavedProgress's saveState, with a retry when the last save failed.
 * `note` replaces it while set, for a save that was asked for and can't
 * happen yet.
 *
 * The status region is always mounted so screen readers already track it
 * when its text changes; a region mounted with its first message is
 * announced unreliably.
 */
function SaveProgressStatus({ saveState, onRetry, idleText = '', note }) {
    let text = idleText;
    if (saveState.status === 'saving') text = 'Saving your progress…';
    if (saveState.status === 'saved') {
        text = `Progress saved at ${timeOf(saveState.savedAt)}.`;
    }
    if (saveState.status === 'error') text = saveState.message;
    if (saveState.status === 'preview') {
        text = "Changes aren't saved while you're previewing.";
    }
    // Why a save that was asked for can't happen yet
    if (note) text = note;

    return (
        <div className="d-flex align-items-center gap-2 small">
            <span
                role="status"
                className={
                    saveState.status === 'error' || note
                        ? 'text-danger'
                        : 'text-muted'
                }
            >
                {text}
            </span>
            {saveState.status === 'error' && onRetry && (
                <Button
                    variant="link"
                    size="sm"
                    className="p-0 align-baseline"
                    onClick={onRetry}
                >
                    Try saving again
                </Button>
            )}
        </div>
    );
}

export default SaveProgressStatus;
